import * as React from 'react';
import cx from 'classnames';

import Button from 'components/Button';
import ClipboardTrigger from 'components/ClipboardTrigger';
import Field from 'components/Field';
import Input from 'components/Input';
import Label from 'components/Label';
import ToastActions from 'actions/ToastActions';

import './styles/CopyToClipboardField.scss';

type Props = {
  label: string;
  value: string;
  theme?: 'white' | 'gray';
};

const CopyToClipboardField = (props: Props) => {
  const { label, value, theme } = props;

  return (
    <Field className="CopyToClipboardField" flush>
      <Label>{label}</Label>
      <Input
        className={cx({
          'CopyToClipboardField--white': theme === 'white',
        })}
        value={value}
        disabled
        noBorder
        append={
          <ClipboardTrigger text={value} onCopy={() => ToastActions.showSuccessToast('Copied!')}>
            <Button level="text" color="brand" weight="semibold">
              Copy
            </Button>
          </ClipboardTrigger>
        }
      />
    </Field>
  );
};

export default CopyToClipboardField;
